// extracted by mini-css-extract-plugin
export default {"entry":"Entry_entry__19qVo","entryWrapper":"Entry_entryWrapper__slNMW","entryRow":"Entry_entryRow__fWq-M","entryLogo":"Entry_entryLogo__QL140","entryTitle":"Entry_entryTitle__R0Js-"};